import React from 'react';
import withUser from "../../../Containers/withUser";
import Logo from "../Logo";
import ConnectWallet from "./ConnectWallet";

const Header = (props) => {

    return (
        <div className={'header'}>
            <div className="container">
                <div className="header_wrapper">
                    <Logo/>
                    <ul className={'header_links'}>
                        <li className={'header_link'}>
                            <a target={'_blank'} rel="noreferrer"
                               href={process.env.REACT_APP_SITE_URL + '/roadmap'}>Roadmap</a>
                        </li>
                        <li className={'header_link'}>
                            <a target={'_blank'} rel="noreferrer"
                               href={'https://coldware.io/coldware_network_whitepaper.pdf'}>Whitepaper</a>
                        </li>
                        <li className={'header_link'}>
                            <a target={'_blank'} rel="noreferrer"
                               href={'https://walletguide.walletconnect.network/'}>Get Wallet</a>
                        </li>
                    </ul>
                    <ConnectWallet
                        {...props}
                    />
                </div>
            </div>
        </div>
    );
};

export default withUser(Header);